import { render, staticRenderFns } from "./teilrechnungslauf.vue?vue&type=template&id=2545041a&scoped=true&"
import script from "./teilrechnungslauf.vue?vue&type=script&lang=js&"
export * from "./teilrechnungslauf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2545041a",
  null
  
)

export default component.exports